import React, { Fragment } from 'react';
import ListMenuItem from './ListMenuItem';

const ListMenu = ({ items = [], id }) => (
  <Fragment key={`key-list-item-${id} `}>
    {items.map((x, index) => (
      <ListMenuItem
        id={`list-item-${id}-${index}`}
        key={`key-list-item-${id}-${index}`}
        icon={x.icon}
        label={x.label}
        onClick={x.onClick}
        items={x.items}
        styleIcon={x.styleIcon}
        className={x.className}
        collapseOpen={x.collapseOpen}
        disabled={x.disabled}
        divider={x.divider}
        classNameIcon={x.classNameIcon}
        classNameText={x.classNameText}
        showNotification={x.showNotification}
        badgeContent={x.badgeContent}
      />
    ))}
  </Fragment>
);

export default ListMenu;
